import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3888a174"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chart-container" }

import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'

import * as echarts from 'echarts'
import { ResizeService } from '@/services/resize.service'
import { ECHARTS_LINE_COLOR, getAssignLineOption, withLineSeriesStyle } from '@/utils/echarts-option/line'
import { useEchartsThemeSync } from '@/composables/use-echarts-theme-sync'
import Card from '@/views/dashboard/_components/card/card.vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import TimeRangeSelect from '@/views/dashboard/_components/time-range-select/time-range-select.vue'
import { TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'

interface ChartData {
  times: string[]
  success: number[]
  failed: number[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'login-trend-chart',
  props: {
    data: { default: () => ({
    times: ['01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
    success: [5, 8, 2, 15, 17, 19, 20, 18, 22, 25, 27, 24, 26, 28, 30, 25, 22, 20, 18, 15, 12, 10, 8],
    failed: [2, 3, 1, 5, 4, 6, 10, 8, 7, 9, 8, 6, 5, 7, 9, 6, 5, 4, 3, 2, 1, 1, 0]
  }) },
    timeRange: { default: TimeRange.DAYS_30 }
  },
  emits: ["update:timeRange"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()
const props = __props

const emit = __emit

const localTimeRange = computed({
  get: () => props.timeRange,
  set: (val) => emit('update:timeRange', val)
})

/** 系列配置 */
const SERIES_CONFIG = computed(() => [
  { field: 'success', name: t('remoteAuth.loginSuccess'), color: ECHARTS_LINE_COLOR.success },
  { field: 'failed', name: t('remoteAuth.loginFailed'), color: ECHARTS_LINE_COLOR.danger },
])

const injector = useReflectiveInjector([ResizeService])
const resizeService = injector.get(ResizeService)

const chartData = computed(() => props.data)
const chartRef = ref<HTMLElement>()
let chartInstance: echarts.EChartsType | null = null

const chartOption = computed(() => {
  if (!chartData.value?.times?.length) {
    return { xAxis: { data: [] }, series: [] }
  }

  return {
    xAxis: {
      data: chartData.value.times,
    },
    legend: {
      width: chartInstance?.getWidth() ? chartInstance.getWidth() - 60 : 'auto',
    },
    series: SERIES_CONFIG.value.map(config => withLineSeriesStyle({
      name: config.name,
      data: chartData.value[config.field as keyof ChartData] as number[],
      smooth: true,
    }, config.color))
  }
})

function initChart () {
  if (!chartRef.value) return
  chartInstance = echarts.init(chartRef.value)
  renderChart()
}

function renderChart () {
  if (!chartInstance) return
  const finalOption: any = getAssignLineOption(chartOption.value, { unit: t('remoteAuth.unitTimes') })
  chartInstance.setOption(finalOption)
}

const resizeSubscribe = resizeService.resizeSubject.subscribe(() => {
  chartInstance && chartInstance.resize()
})

watch(() => chartData.value, () => {
  if (!chartData.value?.times?.length) return
  if (!chartInstance) {
    nextTick(initChart)
  } else {
    renderChart()
  }
}, { deep: true })

useEchartsThemeSync(renderChart)

onMounted(() => {
  if (chartData.value?.times?.length) {
    nextTick(initChart)
  }
})

onUnmounted(() => {
  resizeSubscribe.unsubscribe()
  chartInstance && chartInstance.dispose()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, {
    size: "second",
    title: _ctx.$t('remoteAuth.loginTrendTitle'),
    class: "login-trend-card-wrap"
  }, {
    headerRight: _withCtx(() => [
      _createVNode(TimeRangeSelect, {
        modelValue: localTimeRange.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localTimeRange).value = $event))
      }, null, 8, ["modelValue"])
    ]),
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "chart-wrapper"
        }, null, 512)
      ], 512), [
        [_vShow, chartData.value?.times?.length]
      ]),
      _withDirectives(_createVNode(EmptyData, {
        height: "292px",
        "bg-color": "transparent"
      }, null, 512), [
        [_vShow, !chartData.value?.times?.length]
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})